import React from 'react';

import { Page, PageContent, PageHeader } from '@vlabs/monokit/shared/ui/page';
import { useModal } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import st from './ChecksPage.module.sass';
import {
  ImageTypeCard, VideoAudioTypeCard, VideoAndAudioForm, VideoTypeCard,
} from './components';
import { useImageCheckForm } from './pages/image-checks/image-check-form/useImageCheckForm';
import { useVideoCheckForm } from './pages/video-checks/video-check-form/useVideoCheckForm';

function ChecksPage() {
  const { t } = useTranslation();
  const videoAudioModal = useModal();
  const imageCheckForm = useImageCheckForm();
  const videoCheckForm = useVideoCheckForm();

  return (
    <Page>
      {videoAudioModal.wrap(
        <VideoAndAudioForm onCloseModal={videoAudioModal.close} />,
      )}
      <PageContent>
        <PageHeader title={t('checks:check page title')} />
        <div className={st.Page}>
          <div className={st.TypeCardWrapper}>
            {imageCheckForm.wrap(ImageTypeCard)}
            {videoCheckForm.wrap(VideoTypeCard)}
            <VideoAudioTypeCard onClick={videoAudioModal.open} />
          </div>
        </div>
      </PageContent>
    </Page>
  );
}

export { ChecksPage };
